'use client';

import { EPlatform } from '@/utils/enums/platform-enum';
import type { CampaignsServerData } from '../../types';
import StyleHotProductClientPage from './ClientPage';

interface StyleHotProductsPageProps {
  serverData: CampaignsServerData;
  isAppCommunicationReady: boolean;
  inAppH5: boolean;
  onBottomContentReady?: () => void;
}

export default function StyleHotProductsPage({
  serverData,
  isAppCommunicationReady,
  inAppH5,
  onBottomContentReady,
}: StyleHotProductsPageProps) {
  return (
    <StyleHotProductClientPage
      deviceType={serverData.deviceType as EPlatform}
      runtimeData={serverData.styleHotProductsData}
      runtimeConfig={serverData.runtimeConfig}
      isPreview={serverData.isPreview}
      isAppCommunicationReady={isAppCommunicationReady}
      inAppH5={inAppH5}
      onBottomContentReady={onBottomContentReady}
    />
  );
}
